(() => {
  if (customElements.get('brag-bar')) {
    return;
  }

  class BragBar extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;
      const speedElement = this.querySelector('[data-speed]');
      const speed = speedElement ? parseInt(speedElement.getAttribute('data-speed'), 10) : 1500;

      this.options = {
        spaceBetween: 16,
        speed: speed,
        autoplay: {
          delay: 0
        },
        loop: true,
        slidesPerView: 1.7,
        allowTouchMove: false,
        disableOnInteraction: true,
        breakpoints: {
          749: {
            slidesPerView: 3.7,
          },
          1023: {
            slidesPerView: 5.7,
          },
          1720: {
            slidesPerView: 7.7,
          },
          2220: {
            slidesPerView: 9.7,
          },
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('brag-bar', BragBar);
})();
